import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1dc6b7ce"
import script from "./createBatchDetails.js?vue&type=script&lang=js&external"
export * from "./createBatchDetails.js?vue&type=script&lang=js&external"
import style0 from "./createBatchDetails.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports